import { Component } from '@angular/core';

@Component({
  selector: 'app-section-insert',
  templateUrl: './section-insert.component.html',
  styleUrls: ['./section-insert.component.scss'],
  standalone: false,
})
export class SectionInsertComponent {}
